/**
 * Ejecuta la division: "dividend/divisor".
 * /!\ Devuelve un objeto con el quotien y el resto /!\
 *
 * Infinity es correcto, NaN no.
 *
 * @param {number} dividend: el numero a dividir
 * @param {number} divisor: el divisor
 *
 * @return {object} {quotient, remainder}
 */

import { isValidNumber } from '../number/isValidNumber';
import { countDecimals } from './countDecimals';

export function divide(dividend, divisor) {
  if (!isValidNumber(dividend)) {
    throw new TypeError(`dividend is not a valid number: "${dividend}"`);
  }
  if (!isValidNumber(divisor) || !divisor) {
    throw new TypeError(`divisor is not a valid number: "${divisor}"`);
  }

  const decimals = Math.max(countDecimals(dividend), countDecimals(divisor));
  const pow = decimals ? Math.pow(10, decimals) : 1;

  const quotient = Math.floor((dividend * pow) / (divisor * pow));
  const remainder = ((dividend * pow) % (divisor * pow)) / pow;
  return { quotient, remainder };
}
